export default {
  scene: {
    background: 0xf7e5c1,
    shadow: 0xdd968a,
    fog: {
      color: 0xf7e5c1,
      near: 50,
      far: 400
    }
  },
  sea: {
    width: 800,
    depth: 300,
    range: 12,
    segments: 15,
    amplitude: 20,
    period: 6000,
    waves: [
      {
        color: 0xf9ecc3,
        offset: 25
      },
      {
        color: 0x8e9a9a,
        offset: 30
      },
      {
        color: 0x91b4aa,
        offset: 40
      }
    ],
    rotation: 0,
    position: {
      x: -100,
      y: -5,
      z: 10
    }
  },
  wind: {
    width: 300,
    length: 150,
    speed: 60,
    vertices: {
      count: 8,
      width: 0.2,
      length: 20,
      rotation: 0,
      color: 0xf2f2f2
    },
    rotation: -1,
    position: {
      x: 50,
      y: 10,
      z: 0
    }
  },
  seagull: {
    length: 500,
    width: 200,
    height: 20,
    speed: 50,
    position: {
      x: 0,
      y: 20,
      z: 0
    }
  },
  environment: {
    rotation: Math.PI / 2,
    position: {
      x: 0,
      y: -5,
      z: -60
    }
  },
  character: {
    timeScale: 1.0,
    rotation: Math.PI / 2,
    position: {
      x: -14,
      y: -5,
      z: 4
    }
  },
  player: {
    timeScale: 1.1,
    rotation: Math.PI / 2,
    position: {
      x: -12,
      y: -5,
      z: -4
    }
  },
  speed: 3
}
